import { UNDEF, BLANK } from '../lib';
import { triggerEvent } from '../event-api';
import { getDepsByType, getDep } from '../dependency-manager';
import { priorityList } from '../schedular';
import GlobalStore from './global-store';

var percentRegex = /\%/,
    globalStore = new GlobalStore(),
    handleContainerResize = function () {
  var a,
      b,
      c = {},
      d = function d() {
    var e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m = 0,
        n = parseInt(b.options.resizeTrackingInterval, 10) || 300,
        o = {},
        p = function p() {
      o.itemVar._containerOffsetW = o.parentEle.offsetWidth, o.itemVar._containerOffsetH = o.parentEle.offsetHeight;
    };

    for (e in c) {
      m += 1, f = c[e], g = f.jsVars, i = f.ref, !f.disposed && (h = i && i.parentNode) && (j = i.style) && (percentRegex.test(j.width) || percentRegex.test(j.height)) ? (k = h.offsetWidth, l = h.offsetHeight, !g.resizeLocked && (k && g._containerOffsetW !== k || l && g._containerOffsetH !== l) && (f.resizeTo && f.resizeTo(), o.itemVar = g, o.parentEle = h, setTimeout(p, 1))) : (delete c[e], m -= 1);
    }

    a = m ? setTimeout(d, n) : clearTimeout(a);
  };

  return function (e, f, g) {
    var h = e.jsVars,
        i = f || e.ref && e.ref.parentNode || {};
    b = g, h._containerOffsetW = i.parentNode.offsetWidth, h._containerOffsetH = i.parentNode.offsetHeight, c[e.id] = e, a || (a = setTimeout(d, parseInt(g.options.resizeTrackingInterval, 10) || 300));
  };
}();

function createChart(a, b, c, d, e, f, g, h) {
  var i,
      j,
      k,
      l,
      m,
      n,
      o = b.apiInstance,
      p = b.jsVars,
      q = percentRegex.test(b.width) ? c.offsetWidth : b.width,
      r = percentRegex.test(b.height) ? c.offsetHeight : b.height;
  if (c.FusionCharts = a.items[b.id], b.__state.beforedrawFired = !0, d = d || b.chartType(), i = getDep(d, 'chartapi'), !i && (k = getDep(d, 'maps')) && (i = getDep('maps', 'chartapi'), l = !0), o && o.getName().toLowerCase() !== d.toLowerCase() && (o.remove({
    instant: !0
  }), o = UNDEF), o && o.getName().toLowerCase() === d.toLowerCase() || (o = b.apiInstance = new i(), globalStore.attachChild(o, 'chartAPI')), l) for (var _a in k = k[0], k) {
    k.hasOwnProperty(_a) && (o.config[_a] = k[_a]);
  }
  if (o.addToEnv('core-options', a.options), o.addToEnv('chartInstance', b), o.addToEnv('chart', o), o.addToEnv('chart-container', c), o.addToEnv('eventListeners', []), o.addToEnv('chartWidth', q), o.addToEnv('chartHeight', r), o._removeWaitingJobs(), o.setDummyEImethods(d), o.config.origRenderWidth = b.__state.renderedWidth, o.config.origRenderHeight = b.__state.renderedHeight, 'base' === d || f) isDataErroneous(b, h), setChartMsgStyle(b, g), o.createBaseComponent(), o.getFromEnv('animationManager').setAnimationState('chartmessage'), o.setChartMessage(f, b, c), o.drawChartMessage();else if (!b.__state.resize) {
    if (o.getFromEnv('toolTipController') || (m = getDep('ToolTipController'), n = new m(c), o.addToEnv('toolTipController', n)), o.disposeChartStyleSheet(), c.jsVars = b.jsVars, j = o.eiMethods, b.ref = c, p.type = d, j && 'string' != typeof j) for (var _a2 in j) {
      c[_a2] = j[_a2];
    }
    !h && b.__state.newDataArrived ? triggerEvent('beforedataload', b, {
      data: b.getChartData(getDepsByType('transcoder').JSON, !0, !0)
    }, void 0, dataloadSuccess, dataloadCancel) : dataloadSuccess.call(b, void 0, void 0, h);
  } else o.asyncDraw();
  b.disposed || invokeCallback(b, c, e, {
    hasRendered: !0,
    container: c
  }, a);
}

function dataloadSuccess(a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var d = this,
      e = d.apiInstance,
      f = d.jsVars && d.jsVars.themeObject && d.jsVars.themeObject.getThemedJSONData() || d.getChartData(getDepsByType('transcoder').JSON, !0, !0),
      g = f.data;
  c || triggerEvent('dataloaded', d, {}, [d.id]), d.__state && (d.__state.newDataArrived = !1), e.addToEnv('dataSource', g), e.addToEnv('chart-attrib', g.chart), e._checkInvalidData() || e._checkInvalidSpecificData() ? (e.getContainer('parentgroup') && e.getContainer('parentgroup').hide(), e.createBaseComponent(), e.getFromEnv('animationManager').setAnimationState('chartmessage'), e.setChartMessage(), e.drawChartMessage(), d._sudoSetState(1), triggerEvent('nodatatodisplay', d, {}, [d.id])) : (e.config.hasChartMessage = !1, e.setData(g));
}

function dataloadCancel(a) {
  triggerEvent('dataloadcancelled', a, {}, [a.id]), a.__state && (a.__state.newDataArrived = !1);
}

function postRenderHooks(a, b, c) {
  a.apiInstance.addJob('fire-rendered', function () {
    if ((a.apiInstance.config.hasRendered = c.hasRendered, 'waiting' === a._getState() || 'function' != typeof b || b(c), 'waiting' === a._getState() || (triggerEvent('drawcomplete', a, {
      width: a.jsVars.width,
      height: a.jsVars.height,
      drawCount: a.jsVars.drawCount,
      displayingMessage: 'waiting' === a._getState() || 'error' === a._getState(),
      renderer: 'javascript'
    }, [a.id]), a.__state && delete a.__state.beforedrawFired), !a.disposed) && 'ready' === a._getState()) {
      if (a.__state.rendering && triggerEvent('rendered', a, {
        renderer: 'javascript'
      }, [a.id]), a.disposed) return;
      if (triggerEvent('renderComplete', a, {
        width: a.jsVars.width,
        height: a.jsVars.height,
        drawCount: a.jsVars.drawCount,
        renderer: 'javascript'
      }), a.disposed) return;
      a.__state && delete a.__state.rendering, a.__state.renderComplete = !0;
    }
  }, priorityList.postRender);
}

function invokeCallback(a, b, c, d, e) {
  var f = a.jsVars,
      g = a.apiInstance,
      i = f.fcObj,
      j = i.width,
      k = i.height,
      h = f.overlayButton;
  f.width = g.getFromEnv('chartWidth'), f.height = g.getFromEnv('chartHeight'), f.container = b, f.hcObj = a, f.hcObj.container = b, f.instanceAPI = g, a.hasRendered && f.overlayButtonActive && h && (h.innerHTML = BLANK, h.appendChild(document.createTextNode(f.overlayButtonMessage)), a.container.appendChild(h)), (/\%/g.test(j) || /\%/g.test(k)) && b && b.parentNode && !e.options.preventTrackResize && handleContainerResize(a, b, e), postRenderHooks(a, c, d);
}

function isDataErroneous(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var c = a.options.dataErroneous;
  return !!c && (a.__state.dataReady = !1, b || triggerEvent('dataInvalid', a, {
    error: c
  }, UNDEF, function () {
    triggerEvent('dataxmlinvalid', a, {}, [a.id]);
  }), !0);
}

function setChartMsgStyle(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  a._chartMessageImageStyle = b.image || {}, a._chartMessageStyle = b.message || {};
}

export { globalStore };
export default createChart;